import React from 'react'
import { Row, Col } from 'antd/lib/grid'
import { connectInfiniteHits } from 'react-instantsearch-dom'
import Device from '../Device/Device'

class InfiniteHits extends React.PureComponent {
  static defaultProps = {
    renderSearchBox() {
      return null
    },
  }

  constructor(props) {
    super(props)
    this.sentinel = null
    this.onSentinelIntersection = this.onSentinelIntersection.bind(this)
  }

  componentDidMount() {
    this.intersectionObserver = new IntersectionObserver(
      this.onSentinelIntersection
    )

    this.intersectionObserver.observe(this.sentinel)
  }

  componentWillUnmount() {
    this.intersectionObserver.disconnect()
  }

  onSentinelIntersection(entries) {
    const { hasMore, refineNext } = this.props

    entries.forEach(entry => {
      if (entry.isIntersecting && hasMore) {
        refineNext()
      }
    })
  }

  render() {
    const { hits } = this.props
    //console.log(hits)
    return (
      <React.Fragment>
        <ul>
          <Row gutter={[8, 8]}>
            {hits.map(hit => {
              if (hit.authoringTemplateId === 'AT_device') {
                return (
                  <Col xs={12} md={12} xl={8}>
                    <Device data={hit} />
                  </Col>
                )
              }
              return null
            })}
          </Row>
        </ul>
        <div
          ref={c => {
            this.sentinel = c
          }}
        />
      </React.Fragment>
    )
  }
}
const CustomInfiniteHits = connectInfiniteHits(InfiniteHits)
export default CustomInfiniteHits
